document.addEventListener('DOMContentLoaded', function () {
  const buildBtn = document.querySelector('input[type="button"][value="Build URL"]');
  if (!buildBtn) return;

  buildBtn.addEventListener('click', function () {
    const variants = document.querySelectorAll('input[name="variant"]:checked');
    const cartItems = [];

    variants.forEach((variant) => {
      const qtyInput = document.querySelector(`input[name="quantity_${variant.value}"]`);
      const quantity = qtyInput ? qtyInput.value : 1;
      cartItems.push(`${variant.value}:${quantity}`);
    });

    let url = `https://${Shopify.shop}/cart/${cartItems.join(',')}`;

    const discountCode = document.getElementById('discountCode')?.value.trim();
    const sendTo = document.getElementById('sendVisitorTo')?.value;

    const params = [];
    if (discountCode) params.push(`discount=${encodeURIComponent(discountCode)}`);
    if (sendTo === 'cart') params.push(`storefront=true`);
    else if (sendTo === 'checkout') params.push(`storefront=false`);

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    const output = document.getElementById('generatedUrl');
    if (output) output.value = url;

    const qrCodeImage = document.getElementById('qrCodeImage');
    if (qrCodeImage) {
      qrCodeImage.src = `https://quickchart.io/chart?cht=qr&chl=${encodeURIComponent(url)}&chs=180x180&choe=UTF-8&chld=L|2`;
      qrCodeImage.style.display = 'block';
    }
  });

  const copyBtn = document.getElementById('copyBtn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      const url = document.getElementById('generatedUrl')?.value;
      if (!url) return;
      navigator.clipboard.writeText(url).then(() => alert('URL copied!'));
    });
  }
});
